<template>
  <div class="d-flex justify-center align-center flex-column text-center" style="max-width: 500px; margin: 0 auto;">
    <h2 class="mb-2">Obrigado :)</h2>
    <span>Assim que o seu pagamento for confirmado seu plano será ativoado ou estendido automaticamente.</span>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>

</style>